const DEFAULT_PAGE_TITLE = 'TPRO';
const TITLE_SEPARATOR = '|';

const PAGE_TITLES = {
  DASHBOARD: 'Dashboard',
  IMPORT_PAYROLL: 'Upload Payroll File',
  REVIEW_PAYROLL: 'Review Uploaded Payroll File',
  SCHEDULES: 'Schedules',
  EMPLOYEES: 'Employees',
  EMPLOYER_REF: 'Employer Reference',
  CONTRACT: 'Contracts',
  USERS: 'Users',
  EMPLOYEE_PRINT: 'Employee Print',
  USER_AGREEMENT: 'User Agreement',
  RATES: 'Rates',
  REPORTS: 'Reports',
  ERTN: 'ERTN',
  IMPORT_RATES: 'Upload Rates',
  NOTIFICATIONS: 'Notifications',
  RECONCILIATION: 'Reconciliation',
  RETRO_PAY: 'Retroactive Pay',
  MAINTENANCE: 'Maintenance',
};

const PREFERENCES = {
  ROOT: 'portal:preferences',
  PANEL_STATUS_EMPLOYER: 'panelStatus_employer',
  PANEL_STATUS_EMPLOYEE: 'panelStatus_employee',
};

enum INVITATION_STATUS {
  ACCEPTED = 'Accepted',
  PENDING = 'Pending',
}

type BackendEnvironmentMapper = Record<
  typeof ENVIRONMENT_NAME,
  'Development' | 'Production' | 'Staging'
>;
const BE_ENVIRONMENT_MAPPER: BackendEnvironmentMapper = {
  local: 'Development',
  develop: 'Development',
  uat: 'Development',
  staging: 'Staging',
  production: 'Production',
};

export {
  DEFAULT_PAGE_TITLE,
  TITLE_SEPARATOR,
  PAGE_TITLES,
  PREFERENCES,
  INVITATION_STATUS,
  BE_ENVIRONMENT_MAPPER,
};
